import dayjs from "dayjs";

/**
 * Formats a results-screen date for display. The API sends UTC with no zone designator, so the
 * "Z" is appended before converting to the viewer's local time.
 *
 * @param {string|null|undefined} value e.g. "2026-09-30T18:00:00"
 * @returns {string} e.g. "09/30/2026 08:00:00 PM", or "-" when there is no value.
 */
export const formatResultDate = (value) =>
  value ? dayjs(value + "Z").format("MM/DD/YYYY hh:mm:ss A") : "-";
